import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const DistanceCourses = lazy(
  () =>
    import(
      /* webpackChunkName: "TrainingLibraryDistanceCourses" */ 'modules/trainingLibrary/DistanceCourses/pages/DistanceCourses'
    )
)

const DistanceCoursesRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.root} component={DistanceCourses} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default DistanceCoursesRouting
